import { Card, CardBody, Col, Container, Progress, Row, Table } from "reactstrap"
import BreadCrumb from "../Common/BreadCrumb"
import { PAGE_TITLES } from "../Common/constants"
import { LabelText } from "../Utils/Input"
import CommonButton from "../Utils/CommonButton"
import { useLocation, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Loader } from "../Utils/Loader"
import moment from "moment"
import { customerIdData } from "./constants/constantFunctionsView"
import { fetchCustomer } from "../../slices/customer/fetchcustomer/thunk"
import { fetchSelectedResourceSuccess } from "../../slices/customer/balance/reducer"
import { ToastContainer, toast } from "react-toastify"
import { setSuccessMessage } from "../../slices/toastMessage/action"

export const ChangeSummary = () => {
    const location = useLocation()
    const subId = location?.state?.id
    const attributes = location?.state?.attributes
    const offerName = location?.state?.offerName
    const [loading, setLoading] = useState(false)
    const customerName = location?.state?.customerData?.firstName + " " + location?.state?.customerData?.lastName
    const time = moment().format('DD MMM YYYY')
    const dispatch = useDispatch()
    const customerId = customerIdData()
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(fetchCustomer(setLoading, customerId))
    }, [dispatch])

    const SelectedResourceData = useSelector(state => state.Balance.selectedResource)
    const showSuccessMessage = useSelector(
        (state) => state.SuccessToast.showSuccessMessage
    );
    const fetchChangePlanData = useSelector(state => state.ChangePlan.changePlan)

    useEffect(() => {
        if (showSuccessMessage) {
            toast.success(`Offer Changed Successfully`);
            dispatch(setSuccessMessage(false));
        }
    }, [showSuccessMessage, dispatch]);

    return (
        <div className="page-content bg-white">
            <Container fluid>
                {loading && <Loader />}
                <ToastContainer position="top-center" />
                <BreadCrumb title={PAGE_TITLES.CHANGE_PLAN} pageTitle={PAGE_TITLES.CUSTOMER_SUBSCRIBE} />
                <h5 className="fs-16 fw-semi-bold text-black mb-3">Change Offer Summary</h5>

                <Row className="gy-3">
                    <Col lg={3} md={4} sm={12}>
                        <div className="border border-1 rounded-1 p-3 h-100">
                            <h6 className="fs-16 fw-semibold">CUSTOMER DETAILS</h6>
                            <Row>
                                <Col xl={12} className="mb-3">
                                    <LabelText className="fs-14" displayText={"Customer Name"} />
                                    <p className="rv-label-muted">{customerName}</p>
                                </Col>
                                <Col xs={12} className="mb-3">
                                    <LabelText className="fs-14" displayText={"Customer ID"} />
                                    <p className="rv-label-muted">{fetchChangePlanData?.customerId}</p>
                                </Col>
                            </Row>


                        </div>

                    </Col>
                    <Col lg={9} md={8} sm={12}>
                        <div className="border border-1 rounded-1 p-3 h-100">
                            <h6 className="fs-16 fw-semibold">Subscription Details</h6>
                            <Row>
                                <Col md={4} sm={6} className="mb-3">
                                    <LabelText className="fs-14" displayText={"Subscription ID"} />
                                    <p className="rv-label-muted">{fetchChangePlanData?.subscriptionId}</p>
                                </Col>
                                <Col md={4} sm={6} className="mb-3">
                                    <LabelText className="fs-14" displayText={"Offer Name"} />
                                    <p className="rv-label-muted">{offerName}</p>
                                </Col>
                                <Col md={4} sm={6} className="mb-3">
                                    <LabelText className="fs-14" displayText={"Change Offer Date"} />
                                    <p className="rv-label-muted">{time}</p>
                                </Col>
                                <Col md={4} sm={6} className="mb-3 mb-md-0">
                                    <LabelText className="fs-14" displayText={"Change Offer Effective Date"} />
                                    <p className="rv-label-muted">{moment(fetchChangePlanData?.validFrom).format('DD MMM YYYY')}</p>
                                </Col>
                            </Row>
                            <div className="p-3 border border-1 rounded-1 my-3">
                                <h6 className="fs-16 fw-semibold">Grants</h6>
                                {SelectedResourceData.length ?
                                    SelectedResourceData?.map((resource) => {
                                        return resource.validFrom && (
                                            <div className="mb-4" key={resource.resourceName}>
                                                <LabelText displayText={resource.resourceName} />
                                                <div className="d-flex justify-content-between align-content-between">
                                                    <LabelText className={"text-black fw-bold fs-12"} displayText={`${resource?.remainingBalance} left of ${resource.originalBalance}`} />
                                                    <LabelText className={"text-black fw-bold fs-12"} displayText={`${moment(resource.validFrom).format("DD/MMM/YYYY")} to ${moment(resource.validTo).format("DD/MMM/YYYY")}`} />
                                                </div>
                                                <Progress max={resource?.originalBalance} value={resource?.remainingBalance}></Progress>
                                            </div>
                                        );
                                    })
                                    : <div className="text-center fs-5">Balance Exhausted</div>
                                }
                            </div>
                            {attributes.length > 0 ? <div className="my-3">
                                <h6 className="fs-16 fw-semibold">Attributes</h6>
                                <div className="border border-1 rounded-1 mt-1 overflow-y-auto-200">
                                    <Table className="table">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {attributes.map((attribute, index) => (
                                                <tr key={index} className="border border-0">
                                                    <td className="border border-0">{attribute.name}</td>
                                                    <td className="border border-0">{attribute.value}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div> : null}

                        </div>


                    </Col>
                </Row>
                <div className="d-flex justify-content-end align-items-end mt-5">
                    <div className="d-flex gap-2">
                        <button
                            type="submit"
                            onClick={() => {
                                dispatch(fetchSelectedResourceSuccess([{}]))
                                navigate(`/view-customer/${customerId}`)
                            }}
                            className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                        >
                            <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                            <span className="ps-2 ms-2 me-1 fw-bold">Submit</span>
                        </button>
                    </div>

                </div>
            </Container>
        </div>
    )
}